import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import styled from 'styled-components';
const Container = styled.ul `
  --bgColour: transparent;
  --buttonSize: 24px;
  --fgColour: ${brand.primary.black};
  --itemGap: 16px;
  --itemSize: 24px;

  display: flex;
  align-items: center;
  gap: var(--itemGap);
  color: var(--fgColour);

  &[data-share] {
    --itemGap: ${fluid(8, 16)};
  }
`;
const Item = styled.li ``;
const Link = styled.a `
  ${transition('opacity', 0.25)};

  display: grid;
  height: var(--buttonSize);
  place-content: center;
  border: 0;
  color: currentColor;
  margin: 0;
  background-color: var(--bgColour);
  padding: 0;
  text-decoration: none;
  border-radius: 5000px;

  /* Enable focus styles for Safari */
  &:focus {
    outline: auto;
    outline-color: var(--fgColour);
    outline-offset: 3px;
    outline-width: 1px;
  }

  /* Disable default focus styles if focus visible is supported */
  &:not(:focus-visible):focus {
    outline: none;
  }

  /* Reapply focus styles for focus-visible browsers */
  &:focus-visible {
    outline: auto;
    outline-color: var(--fgColor);
    outline-offset: 3px;
    outline-width: 1px;
  }

  /* Apply hover styles */
  &:hover {
    opacity: 0.7;
  }

  svg {
    display: block;
    height: var(--itemSize);
    color: currentColor;
  }
`;
const Button = styled.button `
  ${transition('opacity', 0.25)};

  display: grid;
  height: var(--buttonSize);
  place-content: center;
  border: 0;
  color: currentColor;
  margin: 0;
  background-color: var(--bgColour);
  padding: 0;
  text-decoration: none;
  border-radius: 5000px;

  /* Enable focus styles for Safari */
  &:focus {
    outline: auto;
    outline-color: var(--fgColour);
    outline-offset: 3px;
    outline-width: 1px;
  }

  /* Disable default focus styles if focus visible is supported */
  &:not(:focus-visible):focus {
    outline: none;
  }

  /* Reapply focus styles for focus-visible browsers */
  &:focus-visible {
    outline: auto;
    outline-color: var(--fgColor);
    outline-offset: 3px;
    outline-width: 1px;
  }

  /* Apply hover styles */
  &:hover {
    opacity: 0.7;
  }

  svg {
    display: block;
    height: var(--itemSize);
    color: currentColor;
  }
`;
const SocialLinksStyles = {
    Button,
    Container,
    Item,
    Link,
};
export default SocialLinksStyles;
